import { actionIdSchema, outcomeIdSchema } from './ids';

/**
 * Registered outcome ids for push notification permission and registration
 * signals (ADR-081). These ids appear in the spec's Product Analytics section
 * and are declared here so the analytics sync tooling can validate them against
 * the catalogue.
 */
export const PUSH_VOIP_OUTCOME_IDS = {
  pushPermissionDecided: outcomeIdSchema.parse('push.permission.decided'),
  pushPermissionObserved: outcomeIdSchema.parse('push.permission.observed'),
  pushPermissionChanged: outcomeIdSchema.parse('push.permission.changed'),
  pushRegistrationSucceeded: outcomeIdSchema.parse('push.registration.succeeded'),
  voipRegistrationSucceeded: outcomeIdSchema.parse('voip.registration.succeeded'),
  voipRegistrationRecoveryTriggered: outcomeIdSchema.parse('voip.registration.recovery-triggered'),
  voipRegistrationRecoveryFailed: outcomeIdSchema.parse('voip.registration.recovery-failed'),
  incomingCallReceived: outcomeIdSchema.parse('incoming.call.received'),
} as const;

/**
 * Registered action id for the Android 14+ full-screen intent permission row.
 * Declared here alongside the outcome ids so the vocabulary is auditable in one
 * place; the constant itself lives in the incoming-call feature slice where it
 * is consumed.
 */
export const PUSH_VOIP_ACTION_IDS = {
  fullScreenIntentPermissionTap: actionIdSchema.parse(
    'telemedicine.full-screen-intent-permission.tap',
  ),
} as const;
